<template>
  <div class="login_page" v-if="is_show">
    <div class="page_item">
      {{ nickname }}
    </div>
    <div class="page_item">
      <van-button type="primary" class="demo-button" @click="test()" v-if="!logining">Test</van-button>
    </div>
    <div class="page_item">
      <van-button type="primary" class="demo-button" @click="regist()" v-if="!logining">注册</van-button>
    </div>
    <div class="page_item">
      <van-button type="primary" class="demo-button" @click="login()" v-if="!logining">登录</van-button>
    </div>
    <div class="page_item">
      <van-button type="primary" class="demo-button" @click="loadCaptcha()" v-if="!logining">验证码</van-button>
    </div>
    <div class="page_item">
      <van-cell-group>
        <van-field v-model='captcha' label-width='80' label-class='text' label="验证码 :" placeholder="请输入验证码" />
      </van-cell-group>
      <img class="code_img" :src="code_img">
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      is_show: true,
      nickname: '',
      logining: false,
      logouting: false,
      captcha: '',
      code_img: null,
    }
  },
  mounted() {

  },
  methods: {
    test() {
      var that = this
      // that.logining = true
      this.$api.ucenterMine({}).then(res => {
        that.nickname = res.data.user.realname
        console.log(res)
      })
    },
    regist() {
      var that = this
      // that.logining = true
      this.$api.regist({
        mobile: '18651835210',
        sms_code: '1234',
        password: '123456',
        password_repeat: '123456',
        realname: 'SZ'
      }).then(res => {
        console.log(res)
      })
    },
    login() {
      var that = this
      // that.logining = true
      this.$api.authPasswordMobileLogin({
        mobile: '18651835210',
        password: 'Gaoyi1309',
      }).then(res => {
        localStorage.setItem('access_token', res.data.token.token_type + ' ' + res.data.token.access_token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        console.log(res)
      })
    },
    loadCaptcha() {
      var that = this
      this.$api.captcha({}).then(res => {
        console.log(res)
        that.code_img = res.data.img
        that.key = res.data.key
      })
    },

  }
}
</script>
<style type="text/css">
.nickname {
  font-size: 32px;
}

.login_page {
  margin: 50px 50px;
}

.page_item {
  margin-bottom: 20px;
}

.demo-button {
  width: 100%;
  margin: 30px auto;
  font-size: 28px;
  height: 75px;

}
</style>
